import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_LAST_VISITORS').plugin(axiosPlugin, {template: "array"});

let fetchUserLastVisitorsAction = redux.fetchActionGet();

export const fetchUserLastVisitors = (userId, query = {}) => fetchUserLastVisitorsAction(`/users/${userId}/last-visitors?${queryString.stringify(query)}`);
export const resetUserLastVisitors = () => redux.actions.reset();

export const userLastVisitors = redux.reducer();